// When hovering over menu links, we want a yellow highlight, but this is switched to a different color by mix-blend-mode. So it has to be this way
$('.header__menu li a').hover(function() {
    $('.link-marker').css('opacity', '0'); // Reset the opacity to 0

    var divWidth = $(this).width(); // Get the width of the hovered element
    var divHeight = $(this).height(); // Get the height of the hovered element
    var divPosition = $(this).offset(); // Get the position of the hovered element

    $('.link-marker').css({
        width: divWidth,
        height: divHeight,
        top: divPosition.top,
        left: divPosition.left,
    }).css('opacity', '1');
}, function() {
    $('.link-marker').css('opacity', '0');
});

$(window).scroll(function() {
    $('.link-marker').css('opacity', '0');
});
